// src/pages/ProjectsPage.jsx
import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom"; // ✅ navigation
import Projects from "../components/Projects";
// ⬇️ Replace this with your actual data source
import allProjects from "../data/projects";

export default function ProjectsPage() {
  const navigate = useNavigate();

  // Build category list from data (with an "All" option)
  const categories = useMemo(() => {
    const set = new Set(allProjects.map((p) => p.category).filter(Boolean));
    return ["All", ...Array.from(set)];
  }, []);

  const [selectedCategory, setSelectedCategory] = useState("All");

  const categoriesFiltered = categories;

  const filteredProjects = useMemo(() => {
    if (selectedCategory === "All") return allProjects;
    return allProjects.filter((p) => p.category === selectedCategory);
  }, [selectedCategory]);

  const handleProjectClick = (projectId) => {
    const path = `/projects/${projectId}`;


    try {
      navigate(path);
    } catch {
      // Fallback if not inside a Router (or navigate not available)
      window.location.href = path;
    }
  };

  return (
    <div
      id="projects-page"
      className="
        relative bg-white dark:bg-gray-900 transition-colors duration-300
        min-h-[calc(100vh-4rem)]
      "
    >
      <div className="relative z-10">
        <Projects
          categoriesFiltered={categoriesFiltered}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          filteredProjects={filteredProjects}
          handleProjectClick={handleProjectClick}
        />
      </div>
    </div>
  );
}
